
import { z } from "zod";

export const TicketPriorityValues = ["NONE", "LOW", "MEDIUM", "HIGH", "URGENT"] as const;
export const TicketPrioritySchema = z.enum(TicketPriorityValues);
export const TicketPriority = TicketPrioritySchema.enum;
export type TicketPriority = (typeof TicketPriorityValues)[number];
export const TicketPriorityDisplayNames = { "NONE": "None",
"LOW": "Low",
"MEDIUM": "Medium",
"HIGH": "High",
"URGENT": "Urgent", } satisfies Record<TicketPriority, string>;
